"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requiredNextLienPositionForHelocRefi = exports.RefiBalanceCalculationStrategy = exports.HelocRefiStatedGoal = void 0;
/**
 * What a second-lien refi applicant says they want to improve, collected on the StatedGoal page.
 * The backend appends it to stated_goal_entry and uses the newest row to route pricing.
 */
var HelocRefiStatedGoal;
(function (HelocRefiStatedGoal) {
    HelocRefiStatedGoal["LOWER_APR"] = "LOWER_APR";
    HelocRefiStatedGoal["LOWER_MONTHLY_PAYMENT"] = "LOWER_MONTHLY_PAYMENT";
    HelocRefiStatedGoal["MORE_CREDIT"] = "MORE_CREDIT";
})(HelocRefiStatedGoal || (exports.HelocRefiStatedGoal = HelocRefiStatedGoal = {}));
/* @TranslateToPython */
var RefiBalanceCalculationStrategy;
(function (RefiBalanceCalculationStrategy) {
    RefiBalanceCalculationStrategy["CAP_MONTHLY_PAYMENT_1_PCT_LIEN_BALANCE"] = "CAP_MONTHLY_PAYMENT_1_PCT_LIEN_BALANCE";
    RefiBalanceCalculationStrategy["USE_ATTESTED_BALANCE_AS_LIEN_BALANCE"] = "USE_ATTESTED_BALANCE_AS_LIEN_BALANCE";
})(RefiBalanceCalculationStrategy || (exports.RefiBalanceCalculationStrategy = RefiBalanceCalculationStrategy = {}));
exports.requiredNextLienPositionForHelocRefi = 3;
